module.exports = __webpack_public_path__ + "static/media/hotcross-bnb.aec97916.svg";